import { render, staticRenderFns } from "./TablaTabs.vue?vue&type=template&id=12bcfe3f&scoped=true"
import script from "./TablaTabs.vue?vue&type=script&lang=js"
export * from "./TablaTabs.vue?vue&type=script&lang=js"
import style0 from "./TablaTabs.vue?vue&type=style&index=0&id=12bcfe3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bcfe3f",
  null
  
)

export default component.exports